import React, { useState, useEffect, useRef } from "react";
import { Button, Image } from "react-bootstrap";
import NavbarLayout from "../components/NavbarLayout";
import Overview from "../components/Employees/Overview";
import TopUsedApps from "../components/Dashboard/topUsedApps/TopUsedApps";
import "../styles/Employees/employeeOverview.scss";
import EmployeesScreenshot from "../components/Employees/EmployeesScreenshot";
import { useNavigate, useParams, useLocation } from "react-router";
import DeviceInfo from '../components/Employees/DeviceInfo';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    setDate,
    setDeviceID,
    setFilterType,
    setFilterChosen,
    setOrganization,
    setDepartment,
    setEmployeeIds,
} from '../features/date/dashboardSlice';
import RangePicker from '../components/CustomComponents/RangePicker/RangePicker';
import { DateRange, DayRange, DayValue } from '../components/Dashboard/Header';
import moment from 'moment';
import { commonPostservice } from "../utils/properties";

export interface Employee {
    
    emp_id: string;
    emp_name: string;
    emp_email: string;
    image: string;
    department: string;
    designation: string;
    organization: string;
    system_status: "online" | "offline" | string;
    device_id: string;
    emp_status: "Active" | "Inactive" | string;
}

const EmployeeOverview = () => {
    const [activeTab, setActiveTab] = useState<string>('overview');
    const [filterShow, setFilterShow] = useState<boolean>(false);
    const [dateRange, setDateRange] = useState<DateRange>([null, null]);
    const [selectedDayRange, setSelectedDayRange] = useState<DayRange>({
        from: null,
        to: null,
    });
    const [rangePickerShow, setRangePickerShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const filterData = useAppSelector((state) => state.filterData);

    const {
        startDate,
        endDate,
        empDeviceId,
        filterType,
        organization,
        department,
        filterChosen
    } = filterData;

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const targetRef = useRef<HTMLDivElement | null>(null);
    const filterList: string[] = ["Today", "Yesterday", "Past 7 days", "Past 30 days", "Custom Date"];
    const filterMap: Record<string, string> = {
        today: "Today",
        yesterday: "Yesterday",
        past_seven: "Past 7 days",
        past_thirty: "Past 30 days",
        month: "Filter by date",
        "Range": "Filter by date",
    };

    const [filterRange, setFilterRange] = useState(
        filterMap[filterChosen] || ""
    );


    const dateToDayValue = (date: Date): DayValue => {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1, // Months are 0-indexed in JavaScript
            day: date.getDate(),
        };
    };
    const [EmployeeData, setEmployeeData] = useState<Employee>({
        emp_id: "",
        emp_name: "",
        emp_email: "",
        image: "",
        department: "",
        designation: "",
        organization: "",
        system_status: "offline",
        device_id: "",
        emp_status: "Inactive",
    });

    const { empid } = useParams();

const roleDetails = JSON.parse(localStorage.getItem("roleDetails") || "{}");
const hasScreenshotAccess: boolean = roleDetails?.features?.screenshot?.status ?? false;
    // useEffect(() => {
    //     window.addEventListener("click", handleClickOutside);
    //     const pathName = window.location.pathname;
    //     const empCode = pathName.split('/')[2];
    //     dispatch(setDeviceID(empCode));
    //     dispatch(setFilterType("employee"));

    //     return () => {
    //         window.removeEventListener("click", handleClickOutside);
    //     };
    // }, [])
    useEffect(() => {
    if (!hasScreenshotAccess && activeTab === "screenshots") {
        setActiveTab("overview");
    }
}, [hasScreenshotAccess]);

    useEffect(() => {
        window.addEventListener("click", handleClickOutside);
        const empCode = location.state?.empCode ?? sessionStorage.getItem('activeEmpCode') ?? "";
        if (location.state?.empCode) {
            sessionStorage.setItem('activeEmpCode', location.state.empCode);
        }
        dispatch(setDeviceID(empCode));
        dispatch(setFilterType("employee"));

        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, [])

    const handleClickOutside = (e: MouseEvent) => {
        if (
            targetRef.current &&
            e.target instanceof Node &&
            !targetRef.current.contains(e.target)
        ) {
            setFilterShow(false);

        }
    };

    const handleFilter = (filterVal: string) => {
        setFilterShow(false);

        let today = new Date();
        let yesterday = moment().subtract(1, "day").toDate();
        if (filterVal !== "Custom Date") {
            setDateRange([null, null]);
            setSelectedDayRange({ from: null, to: null });
            setFilterRange(filterVal);
            rangePickerShow && setRangePickerShow(false);
        }
        else if (filterVal === "Custom Date") {
            setFilterRange("Filter by date");
            setRangePickerShow(true);
            dispatch(setFilterChosen("Range"));

        }
        if (filterVal === "Today") {
            dispatch(setDate({ startDate: today, endDate: today }));
            dispatch(setFilterChosen("today"));

        } else if (filterVal === "Yesterday") {
            dispatch(setDate({ startDate: yesterday, endDate: yesterday }));
            dispatch(setFilterChosen("yesterday"));
        } else if (filterVal === "Past 7 days") {
            dispatch(
                setDate({
                    startDate: moment().subtract(6, "days").toDate(),
                    endDate: today,
                })
            );
            dispatch(setFilterChosen("past_seven"));
        } else if (filterVal === "Past 30 days") {
            dispatch(
                setDate({
                    startDate: moment().subtract(29, "days").toDate(),
                    endDate: today,
                })
            );
            dispatch(setFilterChosen("past_thirty"));

        }
    }

    const handleDateRange = (dateRange: DateRange) => {
        let [newFromDate, newToDate] = dateRange;
        let today = new Date();
        dispatch(setFilterChosen("Range"));
        if (newFromDate === null && newToDate === null) {
            setFilterRange("Filter by date");
        }

        setDateRange(dateRange);
        dispatch(
            setDate({ startDate: newFromDate || today, endDate: newToDate || today })
        );
    };

    const handleTab = (tab: string) => {
        let today = new Date();
        setRangePickerShow(false);
        setActiveTab(tab);
        // setFilterRange("Today");
        // setSelectedDayRange({ from: null, to: null });
        // dispatch(
        //     setDate({ startDate: today, endDate: today })
        // );

    };

    // useEffect(() => {
    //     if (!empDeviceId) return;
    //     if (empDeviceId !== empid) return;
    //     if (empDeviceId) {
    //         let today = new Date();

    //         commonPostservice(`/api/1.0/employee/info?empCode=${empid}`, {}).then((res) => {
    //             if (res.status === 200) {
    //                 setEmployeeData(res?.data);
    //             } else {
    //                 setEmployeeData({
    //                     emp_id: "",
    //                     emp_name: "",
    //                     emp_email: "",
    //                     image: "",
    //                     department: "",
    //                     designation: "",
    //                     organization: "",
    //                     system_status: "offline",
    //                     device_id: "",
    //                     emp_status: "Inactive",
    //                 })
    //             }

    //         })
    //         dispatch(
    //             setDate({ startDate: today, endDate: today })
    //         );
    //     }

    // }, [empDeviceId, empid])

    useEffect(() => {
        if (!empDeviceId || !filterData?.startDate || !filterData?.endDate) return;
        setLoading(true);


        // Remove the empid check — empid is undefined with the new paramless route
        let today = new Date();

        commonPostservice(`/api/1.0/employee/info?empCode=${empDeviceId}`, {}).then((res) => {
            if (res.status === 200) {
                setEmployeeData(res?.data);
            } else {
                setEmployeeData({
                    emp_id: "",
                    emp_name: "",
                    emp_email: "",
                    image: "",
                    department: "",
                    designation: "",
                    organization: "",
                    system_status: "offline",
                    device_id: "",
                    emp_status: "Inactive",
                });
            }
            setLoading(false);
        });

        dispatch(setDate({ startDate: filterData?.startDate || today, endDate: filterData?.endDate || today }));

    }, [empDeviceId, filterData]);
    useEffect(() => {
        const isDateRangeFilter = ["Range", "month"].includes(filterChosen);
        if (isDateRangeFilter && filterData?.startDate && filterData?.endDate) {
            setSelectedDayRange({
                from: dateToDayValue(new Date(filterData.startDate)),
                to: dateToDayValue(new Date(filterData.endDate)),
            });
        }
    }, [
        filterData?.startDate,
        filterData?.endDate,
    ]);

    return (
        <NavbarLayout>
            {loading ?
                <>
                    <div className="d-flex justify-content-center align-items-center h-100 w-100 crt-loader">
                        <img src="/images/loader/content_loader.gif" />
                    </div>
                </> : (
                    <div className="emp-view-contanier">
                        <div className="emp-view-card">
                            <div className="emp-view-header">
                                <div className="title">
                                    <Button className="sorter">
                                        <Image
                                            src="/images/employees/back_arrow.svg"
                                            alt="Back"
                                            onClick={() => navigate(-1)}
                                        />
                                    </Button>
                                    <h3>Employee Overview</h3>
                                </div>
                                <div className="emp-details">
                                    <div className="emp-profile">
                                        <div className="emp-pic-performance">
                                            {EmployeeData?.image ? <Image src={EmployeeData?.image} alt="Profile" key={EmployeeData?.image} /> :
                                                <div
                                                    className={EmployeeData.image ? "pro-pic" : "pro-pic fill-color-avatar"}
                                                >     <span>{EmployeeData.emp_name.charAt(0).toUpperCase()}</span>
                                                </div>}
                                        </div>
                                        <div className="d-flex flex-column gap-2">
                                            <div className="d-flex gap-2 align-items-center">
                                                <p>{EmployeeData?.emp_name}</p>
                                                <span>.</span>
                                                <p> {EmployeeData?.emp_id}</p>
                                            </div>
                                            <p className="emp-mail">{EmployeeData?.emp_email}</p>
                                        </div>
                                        <div className={`online-sts ${EmployeeData?.system_status === "online" ? "online" : "offline"}`}>
                                            <span></span>
                                            <h6>{EmployeeData?.system_status}</h6>
                                        </div>
                                    </div>
                                    <div className="emp-pfl-sts">
                                        <div className="emp-postion">
                                            <h6>Organization</h6>
                                            <p>{EmployeeData?.organization}</p>
                                        </div>
                                        <div className="emp-postion">
                                            <h6>Department</h6>
                                            <p>{EmployeeData?.department}</p>
                                        </div>
                                        <div className="emp-postion">
                                            <h6>Designation</h6>
                                            <p>{EmployeeData?.designation}</p>
                                        </div>
                                        <div className="emp-postion">
                                            <h6>Emp Status</h6>
                                            <p>{EmployeeData?.emp_status}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="emp-body">
                                <div className="emp-tab-cont">
                                    <div className="emp-tab">
                                        <h5
                                            className={`${activeTab === "overview" ? "act-tab" : ""}`}
                                            onClick={() => handleTab("overview")}
                                        >
                                            Overview
                                        </h5>
                                        <h5
                                            className={`${activeTab === "deviceInfo" ? "act-tab" : ""}`}
                                            onClick={() => handleTab("deviceInfo")}
                                        >
                                            Device Info
                                        </h5>
                                        <h5
                                            className={`${activeTab === "productivity" ? "act-tab" : ""}`}
                                            onClick={() => handleTab("productivity")}
                                        >
                                            Productivity
                                        </h5>
                                        {/* <h5
                                            className={`${activeTab === "screenshots" ? "act-tab" : ""}`}
                                            onClick={() => handleTab("screenshots")}
                                        >
                                            Screenshots
                                        </h5> */}
                                        {hasScreenshotAccess && (
                                            <h5
                                                className={`${activeTab === "screenshots" ? "act-tab" : ""}`}
                                                onClick={() => handleTab("screenshots")}
                                            >
                                                Screenshots
                                            </h5>
                                        )}

                                    </div>
                                    {/* ✅ Added 'filter-wrapper' class for tablet-specific positioning */}
                                    <div className='d-flex gap-4 filter-wrapper' ref={targetRef}>
                                        <div className='filter-tab' onClick={(e) => setFilterShow(!filterShow)}>
                                            <p>{filterRange}</p>
                                            <Image src='/images/employees/filter_arrow.svg' alt='Arrow' />
                                            <ul className={`fltr-drop ${filterShow ? '' : 'd-none'}`} onClick={(e) => e.stopPropagation()}>
                                                {filterList?.map((res, i) => (
                                                    <li key={`${i} + ${res}`} onClick={() => handleFilter(res)}>{res}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className={`range-pic-cont ${rangePickerShow || (filterChosen == "month" || filterChosen == "Range") ? '' : 'd-none'}`}>
                                            <RangePicker value={selectedDayRange} onSelect={handleDateRange} />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`mt-${activeTab === "productivity" || activeTab === "screenshots"
                                        ? "small"
                                        : activeTab === "overview"
                                            ? "medium"
                                            : "large"
                                        }`}
                                >
                                    {activeTab === "overview" ? (
                                        <Overview />
                                    ) : activeTab === "productivity" ? (
                                        <TopUsedApps />
                                    ) : activeTab === 'deviceInfo' ? (
                                        <DeviceInfo />
                                    ) : activeTab === "screenshots" && hasScreenshotAccess ? (
                                        <EmployeesScreenshot />
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </NavbarLayout>
    );
};

export default EmployeeOverview;

